import { ICON__heart_regular } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_collections, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { HOOK_GRID2D_CELL__button_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__button_size';
import { REMOTE__collection_image_add } from '@/state/collection/cell/REMOTE__collection_image_add';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__grid2d_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__grid2d_feature';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO_REQUEST__collection_image_add } from '@shared/dto/collection/_requests/DTO_REQUEST__collection_image_add';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { useState } from 'react';
import { HOOK_GRID2D_CELL__image_in_collection_current } from '../_hooks/HOOK_GRID2D_CELL__image_in_collection_current';

interface Props {
  cell: DTO__grid2d_cell;
  entity: DTO__entity_with_grid2d;
  wrapper_class_name: string;
}

export function BUTTON_GRID2D_IMAGE__collection_image_add({ cell, entity, wrapper_class_name }: Props) {
  const dispatch = use_dispatch();

  /*
   *
   */
  const { collection_current } = use_slice_collections(['collection_current']);
  const { user_settings } = use_slice_user(['user_settings']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  /*
   *
   */

  const grid2d_cell_button_size = HOOK_GRID2D_CELL__button_size(user_settings.ui_grid2d_cell_size);

  const is_in_collection_current = HOOK_GRID2D_CELL__image_in_collection_current(cell);

  const [is_loading, set_is_loading] = useState(false);

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();

    if (is_loading) return;

    let request = new DTO_REQUEST__collection_image_add();
    request.hash_sha256_content = cell.hash_sha256_content;
    request.collection_id = collection_current._id; //todo:get id from collection current

    set_is_loading(true);

    await dispatch(REMOTE__collection_image_add([request]));

    set_is_loading(false);
  }

  /*
   * METHODS
   */

  /*
   * RENDERS
   */
  if (is_in_collection_current) return null;
  //
  if (collection_current.is_stub()) return null;
  if (!collection_current.is_grid2d_feature_possible(ENUM__grid2d_feature.IMAGE_INTERNAL__DELETE)) return null; //action is not allowed on this grid2d
  //
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_UPDATE)) return null;

  return (
    <div className={wrapper_class_name}>
      <UI_PRIMITIVE__button_with_icon_animated
        Icon={ICON__heart_regular}
        disabled={is_loading}
        iconClassNameBase={`!text-component-item-foreground !size-4 !duration-300
             ${user_settings.ui_grid2d_cell_size === ENUM__grid2d_cell_size.L ? '!size-7' : ''}`}
        iconClassNameHovered="!text-bar-foreground"
        variant="no-border-on-component"
        onClick={onClick}
        className={`p-0 rounded-lg  bg-bar  ${is_in_collection_current ? 'cursor-pointer' : 'cursor-copy'}
          ${grid2d_cell_button_size}`}
      />
    </div>
  );
}
